import { ShippingMethodInput } from 'lib/types'
import { FetchResult } from '@apollo/client'
import { ServiceDependencies, replaceMutation } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface SetShippingMethodOnCartMutationObject {
  mutation: {
    setShippingMethodsOnCart: {
      __args: {
        input: {
          cart_id: string
          shipping_methods: [
            {
              carrier_code: string
              method_code: string
              [key: string]: any
            }
          ]
        }
      }
      [key: string]: any
    }
  }
}

export const setShippingMethodOnCartMutationObject: SetShippingMethodOnCartMutationObject = {
  mutation: {
    setShippingMethodsOnCart: {
      __args: {
        input: {
          cart_id: '',
          shipping_methods: [
            {
              carrier_code: '',
              method_code: ''
            }
          ]
        }
      }
    }
  }
}

interface SetShippingMethodOnCartMutationInput {
  cartId: string
  shippingMethod: ShippingMethodInput
}

export type SetShippingMethodOnCartMutation = (input: SetShippingMethodOnCartMutationInput) => Promise<FetchResult<any>>

export const createSetShippingMethodOnCartMutation = ({ getMutations, getQueries }: ServiceDependencies): SetShippingMethodOnCartMutation => async ({ cartId, shippingMethod }) => {
  const queries = getQueries()
  const mutation = getMutations().setShippingMethodOnCartMutation

  queries.cartQuery.items = false
  mutation.mutation.setShippingMethodsOnCart.cart = {
    ...queries.cartQuery,
    ...queries.cartPrices,
    ...queries.shippingAddresses
  }

  const {
    carrierCode,
    methodCode,
    ...rest
  } = shippingMethod

  mutation.mutation.setShippingMethodsOnCart.__args.input.cart_id = cartId
  mutation.mutation.setShippingMethodsOnCart.__args.input.shipping_methods[0].carrier_code = carrierCode
  mutation.mutation.setShippingMethodsOnCart.__args.input.shipping_methods[0].method_code = methodCode

  return apolloClient.mutate({
    mutation: gql`${replaceMutation(jsonToGraphQLQuery(mutation), rest)}`,
    fetchPolicy: 'no-cache'
  })
}
